module.exports = __webpack_public_path__ + "static/img/img_banner_mo.c9849c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/taola/_images/img_banner_mo.png
// module id = PSw8
// module chunks = 0